export const insightsTourSteps = [{
  target: '.dashboard-header',
  header: {
    title: 'Welcome to your MikMak Dashboard!',
  },
  content: 'This is the home of your brand\'s metrics and insights ' +
    'from your MikMak Commerce Experiences. ' +
    'It updates every day at 8am EST, so make sure to bookmark the link and come back often.',
  params: {
    enableScrolling: true,
    /**
     * Any valid Popper.js placement.
     * See https://popper.js.org/popper-documentation.html#Popper.placements
     */
    placement: 'auto',
  },
},
{
  target: '.dashboard-header',
  header: {
    title: 'Navigating the MikMak Dashboard',
  },
  content: 'There are three pages of the Dashboard. You\'re in Insights, ' +
    'which provides information on overall performance and breakdowns by key dimensions. ' +
    'Explorer is where you can build out custom reports. ' +
    'Sales Insights, if your brand has opted-in, is ' +
    'where you will see sales data for select retailers.',
  params: {
    enableScrolling: false,
    placement: 'auto-start',
  },
},
{
  target: '.glossary-link',
  header: {
    title: 'Downloading the MikMak Glossary',
  },
  content: 'You can always access the MikMak Glossary here to find definitions ' +
    'for all of the metrics and dimensions you\'ll find in Dashboard.',
  params: {
    enableScrolling: false,
    placement: 'auto-start',
  },
},
{
  target: '.date-range-control-wrapper',
  header: {
    title: 'Adjusting the Date Range',
  },
  content: 'The date range is customizable to your needs. ' +
    'As you change the start and end dates, all the data in Insights will automatically update. ' +
    'You can use predefined time frames in the dropdown, too.',
  params: {
    enableScrolling: false,
  },
},
{
  target: '.top-level-metrics',
  header: {
    title: 'Viewing Overall Performance',
  },
  content: 'View your brand\'s top level metrics for the selected time period. ' +
    'These cards show trend lines to indicate how the metric has changed over time.',
  params: {
    enableScrolling: false,
    placement: 'top',
  },
},
{
  target: '.date-range-control-wrapper',
  header: {
    title: 'Performance Over Time',
  },
  content: 'For example, if you chose the past 7 days in the date selector, ' +
    'you\'ll see how performance compared to the previous 7 days before that.',
  params: {
    enableScrolling: false,
  },
},
{
  target: '.report-field-row',
  header: {
    title: 'Applying a Filter',
  },
  content: 'Filters allow you to pull a subset of your data. ' +
    'To add filters, you can open the side panel by clicking on the Add Filter. ' +
    'Click "Apply" to apply your filters to the report.',
  params: {
    enableScrolling: false,
  },
},
{
  target: '.Platforms',
  header: {
    title: 'Exploring Performance Breakdowns',
  },
  content: 'Dig deeper by looking at key metrics by Platform, Retailer, and more. ' +
    'Users in different environments can behave quite differently!',
  params: {
    enableScrolling: false,
    placement: 'auto',
  },
},
{
  target: '.Retailers',
  header: {
    title: 'Additional Performance Breakdowns',
  },
  content: 'You can sort any table in Dashboard by clicking on the metric name. ' +
    'You can also click the ' +
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M3.33333 12C3.33333 12.3667 3.63333 12.6667 4'+
    ' 12.6667H12C12.3667 12.6667 12.6667 12.3667 12.6667 12V8.66667C12.6667 8.3 12.9667 8 13.3333 8C13.7'+
    ' 8 14 8.3 14 8.66667V12.6667C14 13.4 13.4 14 12.6667 14H3.33333C2.6 14 2 13.4 2 12.6667V3.33333C2 2.6'+
    ' 2.59333 2 3.33333 2H7.33333C7.7 2 8 2.3 8 2.66667C8 3.03333 7.7 3.33333 7.33333 3.33333H4C3.63333'+
    ' 3.33333 3.33333 3.63333 3.33333 4V12ZM10 3.33333C9.63333 3.33333 9.33333 3.03333 9.33333 2.66667C9.33333'+
    ' 2.3 9.63333 2 10 2H13.3333C13.7 2 14 2.3 14 2.66667V6C14 6.36667 13.7 6.66667 13.3333 6.66667C12.9667'+
    ' 6.66667 12.6667 6.36667 12.6667 6V4.27333L6.58 10.36C6.32 10.62 5.9 10.62 5.64 10.36C5.38 10.1 5.38 9.68'+
    ' 5.64 9.42L11.7267 3.33333H10Z" fill="#FFFFFF"/></svg>'+
    ' to dive deeper into the data in Explorer.',
  params: {
    placement: 'auto',
  },
},
{
  target: '.dashboard-header',
  header: {
    title: 'Congratulations!',
  },
  content: 'You just completed your Insights walkthrough. ' +
    'Click "Finish" to start reviewing your data on your own, ' +
    'or click Explorer in the top-left to start that guided walkthrough.',
  params: {
    enableScrolling: true,
    placement: 'auto',
  },
},
];

export const explorerTourSteps = [{
  target: '.dashboard-header',
  header: {
    title: 'Welcome to Explorer',
  },
  content: 'Explorer allows you to create custom reports using Dimensions, Metrics, ' +
    'and Filters as building blocks. We\'ll review those together.',
  params: {
    enableScrolling: true,
    placement: 'auto',
  },
},
{
  target: '.pre-selected-report',
  header: {
    title: 'Pre-Configured Reports',
  },
  content: 'We\'ve created some custom reports for you already. ' +
    'To access them, simply click "Report" and then the report you want. ' +
    'It will auto-populate the template for you.',
  params: {
    enableScrolling: false,
    placement: 'auto',
  },
},
{
  target: '.date-input',
  header: {
    title: 'Adjusting the Date Range',
  },
  content: 'Whether using a pre-configured report or building one from scratch, ' +
    'you can select your desired start and end date for your report here.',
  params: {
    enableScrolling: false,
    placement: 'auto',
  },
},
{
  target: '.report-field-row:nth-child(1)',
  header: {
    title: 'Selecting a Dimension',
  },
  content: 'Dimensions are attributes of your data like a Campaign Name or Channel. ' +
    'You can find all dimensions in this view, and search for them in the top bar. ' +
    'You must have at least one dimension to run a report.',
  params: {
    enableScrolling: false,
    placement: 'left',
  },
},
{
  target: '.report-field-row:nth-child(2)',
  header: {
    title: 'Selecting a Metric',
  },
  content: 'Next in the side panel you\'ll see Metrics. ' +
    'Metrics are quantitative measurements like Measurable Views or Purchase Intent Clicks. ' +
    'You must have at least one metric to run a report.',
  params: {
    enableScrolling: false,
    placement: 'left',
  },
},
{
  target: '.report-field-row:nth-child(3)',
  header: {
    title: 'Selecting a Filter',
  },
  content: 'Filters allow you to pull a subset of your data. ' +
    'You can view options to filter in the last section of the side panel. ' +
    'Adding a filter is not required to run a report.',
  params: {
    enableScrolling: false,
    placement: 'left',
  },
},
{
  target: '.date-select.main-button-wrapper',
  header: {
    title: 'Running a Report',
  },
  content: 'After you\'ve selected your Dimension, Metric, and ' +
    '(optional) Filter, click "Apply" to generate your results.',
  params: {
    enableScrolling: false,
    placement: 'auto',
  },
},
{
  target: '.explore-table',
  header: {
    title: 'Viewing Your Data',
  },
  content: 'You can sort the elements of the data table by clicking the column header. ' +
    'You can also download the data in a CSV format.',
  params: {
    enableScrolling: false,
    placement: 'auto',
  },
},
{
  target: '.actions-button.timeseries',
  header: {
    title: 'Showing Time Series',
  },
  content: 'For reports where you have Event Date as a Dimension, ' +
    'you can view a line chart of your data by clicking this icon.',
  params: {
    enableScrolling: false,
    placement: 'auto',
  },
},
{
  target: '.dashboard-header',
  header: {
    title: 'Congratulations!',
  },
  content: 'You just completed your Explorer View walkthrough. ' +
    'You\'ll be a pro in no time! Click "Finish" to continue viewing on your own.',
  params: {
    enableScrolling: true,
    placement: 'auto',
  },
},
];
export const salesInsightsTourSteps = [{
  target: '.dashboard-header',
  header: {
    title: 'Welcome to MikMak Sales Insights!',
  },
  content: 'This is where you’ll find your Sales Insights from Retailers.',
  params: {
    enableScrolling: true,
    placement: 'auto',
  },
},
{
  target: '.sales-insights-tooltips',
  header: {
    title: 'Retailer Attribution Windows',
  },
  content: 'You can hover over these icons to find what the ' +
    'attribution windows are for each retailer.',
  params: {
    enableScrolling: false,
    placement: 'auto',
  },
},
{
  target: '.date-range-control-wrapper',
  header: {
    title: 'Date Range',
  },
  content: 'You can select a start and end date for viewing Sales Insight data. ' +
    'We recommend viewing data on a monthly or quarterly basis.',
  params: {
    enableScrolling: false,
    placement: 'auto',
  },
},
{
  target: '.top-level-metrics',
  header: {
    title: 'Top Insights',
  },
  content: 'View your Sales Insights\' top level metrics for the selected time period. ' +
    'These Dashboard cards show a macro level view of your performance, ' +
    'with basket composition breakouts for brand and non-brand product sales.',
  params: {
    enableScrolling: false,
    placement: 'top',
  },
},
{
  target: '.report-field-row',
  header: {
    title: 'Filters',
  },
  content: 'Filters allow you to pull a subset of your data. ' +
    'To apply a filter, you can select the category to filter on and check the values within it.',
  params: {
    enableScrolling: true,
    placement: 'auto',
  },
},
{
  target: '.Categories',
  header: {
    title: 'Performance Breakdowns',
  },
  content: 'Dig deeper into your data by looking at the breakdown of Attributable Sales and Unit Sales ' +
    'by dimensions like Campaign, Platform, and Category.',
  params: {
    enableScrolling: true,
    placement: 'top-start',
  },
},
{
  target: '.Brand',
  header: {
    title: 'Products',
  },
  content: 'You can see a list of the top selling products from consumer transactions. ' +
    'We show you your top Brand products in addition to non-brand products.',
  params: {
    enableScrolling: true,
    placement: 'top',
  },
},
{
  target: '.dashboard-header',
  header: {
    title: 'Congratulations!',
  },
  content: 'You completed your Sales Insights walkthrough. ' +
    'Click "Finish" to view your Sales Insights!',
  params: {
    enableScrolling: true,
    placement: 'auto',
  },
},
];

export const benchmarksTourSteps = [
  {
    target: '.dashboard-header',
    header: {
      title: 'Welcome to Benchmark Insights',
    },
    content: 'This is where you can find performance intelligence at ' +
      'the brand- and category-level to understand how you stack up ' +
      'against the competition and against your own performance over time.',
    params: {
      enableScrolling: true,
      placement: 'auto',
    },
  },
  {
    target: '.tab.active',
    header: {
      title: 'Navigating Benchmarks',
    },
    content: 'There are two views in the Benchmarks Insights tab.' +
      '<br><br>Category Benchmarks allows you to see your performance compared to ' +
      'the average performance of your category.<br><br>Brand Benchmarks allows you ' +
      'to quickly compare two date ranges for your own brand\'s performance. ' +
      'Note: You need 1,000 page views in a given quarter to unlock Brand Benchmarks.',
    params: {
      enableScrolling: false,
      placement: 'auto',
    },
  },
  {
    target: '.report-field-row > .badges > .badge-wrapper > .primary',
    header: {
      title: 'Selecting your Brand',
    },
    content: 'Select the brand you want to review here.',
    params: {
      enableScrolling: false,
      placement: 'auto',
    },
  },
  {
    target: '.date-range-control',
    header: {
      title: 'Adjusting the Dates',
    },
    content: 'The left calendar picker lets you select what date range ' +
      'to view for your brand\'s data.<br><br>Once you select the dates, you can click ' +
      '"Apply and Continue" to open the dropdown to the right to select the quarterly ' +
      'Benchmark you want to look at.<br><br>For Brand benchmarks, you can select custom ' +
      'time-frames for both data sets you plan on comparing/contrasting.',
    params: {
      enableScrolling: false,
      placement: 'auto',
    },
  },
  {
    target: '.benchmarks-card-content',
    header: {
      title: 'Reviewing Benchmarks',
    },
    content: 'For the four main metrics, we show a chart and table with your performance ' +
      'against the benchmark. You can hover over the bars to see a tooltip with the data points.',
    params: {
      enableScrolling: false,
      placement: 'auto',
    },
  },
  {
    target: '.main-button.primary',
    header: {
      title: 'Exporting Data',
    },
    content: 'You can export the data for all of the tables with one click! ' +
      'This produces a .zip folder with csv\'s for each report card.',
    params: {
      enableScrolling: false,
      placement: 'auto',
    },
  },
  {
    target: '#link-container',
    header: {
      title: 'Viewing More Data',
    },
    content: 'By default, we show the top 5 values in the tables. ' +
      'To see the full data set, click "View More" in the bottom right corner of ' +
      'the report window to open the expanded view.',
    params: {
      enableScrolling: false,
      placement: 'auto',
    },
  },
  {
    target: '.benchmarks-card-content',
    header: {
      title: 'Viewing the chart',
    },
    content: 'Here, you can see the full dataset for a given metric. You can adjust the slider ' +
      'below the chart to view other sections of the table when there are more than ten values.',
    params: {
      enableScrolling: true,
      placement: 'auto',
    },
    before: _ => new Promise((resolve, _reject) => {
      document.querySelector('#link-container .link').click();
      resolve();
    }),
  },
  {
    target: '#benchmarks-big-table .table-header',
    header: {
      title: 'Viewing the table',
    },
    content: 'You can sort this table and select or unselect rows. ' +
      'This will control whether or not they appear in the chart above!',
    params: {
      enableScrolling: true,
      placement: 'auto',
    },
  },
  {
    target: 'button.main-button.primary',
    header: {
      title: 'Exporting data',
    },
    content: 'Similar to the main page, you can export this dataset here. ' +
      'Unlike the main page, this will only export the data for this Purchase Intent Rate view.',
    params: {
      enableScrolling: true,
      placement: 'auto',
    },
  },
  {
    target: '.breadcrumb-container .link-container .icon',
    header: {
      title: 'Changing the Metric',
    },
    content: 'You can click here to switch the Purchase Intent Rate view you\'re looking at!',
    params: {
      enableScrolling: true,
      placement: 'auto',
    },
  },
  {
    target: '.dashboard-header',
    header: {
      title: 'Congratulations!',
    },
    content: 'You just completed your Benchmark Insights walkthrough. ' +
      'You\'ll be a pro in no time! Click "Finish" to continue viewing on your own.',
    params: {
      enableScrolling: true,
      placement: 'auto',
    },
  },
];

const shopperIntelligenceWaitMs = 400;

export const shopperIntelligenceTourSteps = [
  {
    target: '.dashboard-header',
    header: {
      title: 'Welcome to Shopper Intelligence',
    },
    content: 'This is where you\'ll learn who your shoppers are, ' +
      'connecting your eCommerce insights to thousands of demographic ' +
      'and psychographic data points.',
    params: {
      enableScrolling: false,
      placement: 'auto',
    },
  },
  {
    target: '.show-report-button',
    header: {
      title: 'Navigating Shopper Intelligence',
    },
    content: 'Similar to the Explorer page, you can easily create robust ' +
      'Shopper Intelligence reports in just a few clicks. ' +
      'Begin by clicking the Build Report button.',
    before: type => new Promise((resolve, _reject) => {
      if (type !== 'previous') {
        resolve();
      }

      const slideOutCancelButtonSelector = '.slideout-header .right-options button.secondary';

      const slideOutCancelButton = document.querySelector(slideOutCancelButtonSelector);

      slideOutCancelButton.click();

      // Need to wait for slideout transition to complete to properly position next step.
      setTimeout(() => {
        resolve();
      }, shopperIntelligenceWaitMs);
    }),
    params: {
      enableScrolling: false,
      placement: 'auto',
    },
  },
  {
    target: '.dimensions-container .dimensions.section .title',
    header: {
      title: 'Selecting your Dimension',
    },
    content: 'Start by selecting the Dimension you want to view in your report. ' +
      'These are demographic and psychographic segments like ' +
      'Age, Household variables, and Lifestyles & Interests.',
    before: type => new Promise((resolve, _reject) => {
      if (type !== 'next') {
        resolve();
      }

      const buildReportButton = document.querySelector('.show-report-button button');

      buildReportButton.click();

      // Need to wait for slideout transition to complete to properly position next step.
      setTimeout(() => {
        resolve();
      }, shopperIntelligenceWaitMs);
    }),
    params: {
      enableScrolling: false,
      placement: 'right',
    },
  },
  {
    target: '.dimensions-container .metrics.section .title',
    header: {
      title: 'Selecting metrics',
    },
    content: 'Select all your desired Metrics here, and then ' +
      'they will appear in the Report Preview section to the right. ' +
      'You\'ll notice the cursor change when hovering over them, ' +
      'indicating the ability to "drag and drop" them in any order you\'d like.',
    params: {
      enableScrolling: false,
      placement: 'right',
    },
  },
  {
    target: '.add-filters-button button',
    header: {
      title: 'Adding Filters',
    },
    content: 'Now that you\'ve added your Dimension and Metrics, ' +
      'you can move on to the Filters section.',
    before: type => new Promise((resolve, _reject) => {
      if (type !== 'previous') {
        resolve();
      }

      const dimensionsMetricsTab = document.querySelector('#demographics-tabs div:nth-child(1)');

      dimensionsMetricsTab.click();

      resolve();
    }),
    params: {
      enableScrolling: false,
      placement: 'bottom',
    },
  },
  {
    target: '.filter-type-box .title',
    header: {
      title: 'Applying Basic Filters',
    },
    content: 'This is where you can further segment your report by ' +
      'refining the Dimensions included. For example, ' +
      'if you selected Age as your Dimension in the previous screen, ' +
      'you can further filter the report to only shoppers who viewed a particular media campaign.',
    before: type => new Promise((resolve, _reject) => {
      const addFiltersButton = document.querySelector('.add-filters-button button');

      if (type === 'next') {
        addFiltersButton.click();
      }

      setTimeout(() => {
        const basicFiltersRadioButton = document.querySelector('#radio-input-Basic-Basic');

        basicFiltersRadioButton.click();
      }, shopperIntelligenceWaitMs);

      resolve();
    }),
    params: {
      enableScrolling: false,
      placement: 'left',
    },
  },
  {
    target: '.filter-type-box .title',
    header: {
      title: 'Applying Advanced Filters',
    },
    content: 'Advanced Filtering allows you to use statements like ' +
      '"include all of" or "contains none of" to create more sophisticated reports ' +
      'using all available Shopper Intelligence and MikMak Insights Dimensions.',
    params: {
      enableScrolling: false,
      placement: 'left',
    },
    before: _ => new Promise((resolve, _reject) => {
      document.querySelector('#radio-input-Advanced-Advanced').click();
      resolve();
    }),
  },
  {
    target: '.slideout-header .save.button',
    header: {
      title: 'Viewing report',
    },
    content: 'Once you\'re done, click "Save" to run and view your report!',
    params: {
      enableScrolling: false,
      placement: 'left',
    },
  },
];
